import 'svelte/internal/disclose-version';
import * as $ from 'svelte/internal/client';
import { getContext } from 'svelte';

var root = $.from_html(`<input type="radio"/>`);

export default function Radio_group_item($$anchor, $$props) {
	$.push($$props, true);

	let className = $.prop($$props, 'class', 3, '');
	const radioGroup = getContext('radioGroup');
	const checked = $.derived(() => radioGroup.getValue() === $$props.value);

	function handleClick() {
		radioGroup.setValue($$props.value);
	}

	var input = root();

	$.remove_input_defaults(input);
	input.__click = handleClick;

	$.template_effect(() => {
		$.set_attribute(input, 'id', $$props.id);
		$.set_value(input, $$props.value);
		$.set_checked(input, $.get(checked));
		$.set_class(input, 1, `h-4 w-4 rounded-full border-2 border-primary text-primary focus:ring-2 focus:ring-primary focus:ring-offset-2 ${className() ?? ''}`);
	});

	$.append($$anchor, input);
	$.pop();
}

$.delegate(['click']);
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJuYW1lcyI6W10sInNvdXJjZXMiOlsicmFkaW8tZ3JvdXAtaXRlbS5zdmVsdGUiXSwic291cmNlc0NvbnRlbnQiOlsiPHNjcmlwdCBsYW5nPVwidHNcIj5cbiAgaW1wb3J0IHsgZ2V0Q29udGV4dCB9IGZyb20gJ3N2ZWx0ZSc7XG5cbiAgbGV0IHtcbiAgICB2YWx1ZSxcbiAgICBpZCxcbiAgICBjbGFzczogY2xhc3NOYW1lID0gJycsXG4gIH06IHtcbiAgICB2YWx1ZTogc3RyaW5nO1xuICAgIGlkPzogc3RyaW5nO1xuICAgIGNsYXNzPzogc3RyaW5nO1xuICB9ID0gJHByb3BzKCk7XG5cbiAgY29uc3QgcmFkaW9Hcm91cCA9IGdldENvbnRleHQ8e1xuICAgIGdldFZhbHVlOiAoKSA9PiBzdHJpbmc7XG4gICAgc2V0VmFsdWU6ICh2YWx1ZTogc3RyaW5nKSA9PiB2b2lkO1xuICB9PigncmFkaW9Hcm91cCcpO1xuXG4gIGNvbnN0IGNoZWNrZWQgPSAkZGVyaXZlZChyYWRpb0dyb3VwLmdldFZhbHVlKCkgPT09IHZhbHVlKTtcblxuICBmdW5jdGlvbiBoYW5kbGVDbGljaygpIHtcbiAgICByYWRpb0dyb3VwLnNldFZhbHVlKHZhbHVlKTtcbiAgfVxuPC9zY3JpcHQ+XG5cbjxpbnB1dFxuICB0eXBlPVwicmFkaW9cIlxuICB7aWR9XG4gIHt2YWx1ZX1cbiAge2NoZWNrZWR9XG4gIG9uY2xpY2s9e2hhbmRsZUNsaWNrfVxuICBjbGFzcz1cImgtNCB3LTQgcm91bmRlZC1mdWxsIGJvcmRlci0yIGJvcmRlci1wcmltYXJ5IHRleHQtcHJpbWFyeSBmb2N1czpyaW5nLTIgZm9jdXM6cmluZy1wcmltYXJ5IGZvY3VzOnJpbmctb2Zmc2V0LTIge2NsYXNzTmFtZX1cIlxuLz5cbiJdLCJtYXBwaW5ncyI6Ijs7U0FDVyxVQUFVLFFBQVEsUUFBUTs7Ozs0REFEckMsQ0FBQzs7O0tBTVUsU0FBUywrQkFBRyxFQUFFO09BT2pCLFVBQVUsR0FBRyxVQUFVLENBRzFCLFlBQVk7T0FFVCxPQUFPLG1CQUFZLFVBQVUsQ0FBQyxRQUFROztVQUVuQyxXQUFXLEdBQUcsQ0FBQztFQUN0QixVQUFVLENBQUMsUUFBUTtDQUNyQixDQUFDOzs7OztpQkFRUSxXQUFXOzs7Ozs7eUlBQ2tHLFNBQVM7Ozs7O0FBUmxJLENBQUM7OyJ9